var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottombar"},[_c('div',{staticClass:"time"},[_vm._v("\n    "+_vm._s(_vm.time)+" | "+_vm._s(_vm.countdown.days)+":"+_vm._s(_vm.countdown.hours)+":"+_vm._s(_vm.countdown.mins)+":"+_vm._s(_vm.countdown.secs)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"total"},[_vm._v("\n    "+_vm._s(_vm.overlayData.donationTotal)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-250709b5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bottombar.vue
// module id = null
// module chunks = 